(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alma-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('alma-announcement')) {
  customElements.define('alma-announcement', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.paused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.onClick = event => {
        if (event.target.closest('[data-prev]')) this.change(-1);
        if (event.target.closest('[data-next]')) this.change(1);
        if (event.target.closest('[data-pause]')) {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }
      };
      this.onVisibility = () => this.schedule();
      this.onMotion = () => {
        this.paused = this.motion.matches;
        this.updatePause();
        this.schedule();
      };
      this.onEnter = () => clearInterval(this.timer);
      this.onLeave = () => this.schedule();
      this.addEventListener('click', this.onClick);
      this.addEventListener('focusin', this.onEnter);
      this.addEventListener('focusout', this.onLeave);
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.motion.addEventListener('change', this.onMotion);
      this.onMotion();
    }
    change(step) {
      if (this.slides.length < 2) return;
      this.index = (this.index + step + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    }
    updatePause() {
      const button = this.querySelector('[data-pause]');
      if (!button) return;
      button.setAttribute('aria-pressed', String(this.paused));
      button.setAttribute('aria-label', this.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.querySelector('span').textContent = this.paused ? '▷' : 'Ⅱ';
    }
    schedule() {
      clearInterval(this.timer);
      if (!this.hasAttribute('data-autoplay') || this.slides.length < 2 || this.paused || document.hidden || this.contains(document.activeElement) || this.matches(':hover')) return;
      this.timer = setInterval(() => this.change(1), 6000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('focusin', this.onEnter);
      this.removeEventListener('focusout', this.onLeave);
      this.removeEventListener('mouseenter', this.onEnter);
      this.removeEventListener('mouseleave', this.onLeave);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.motion.removeEventListener('change', this.onMotion);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alma-bag-landing"] && !Shopify.designMode) return;
  try {
    
function initAlmaBagLandings(){
  document.querySelectorAll('[data-alma-landing]').forEach(root=>{
    if(root.dataset.almaReady)return;
    root.dataset.almaReady='true';
    root.addEventListener('click',event=>{
      const thumb=event.target.closest('[data-photo-src]');
      if(!thumb||!root.contains(thumb))return;
      const main=root.querySelector('.aslp-main-photo');
      if(!main)return;
      main.removeAttribute('srcset');
      main.src=thumb.dataset.photoSrc;
      main.alt=thumb.dataset.photoAlt||'';
      root.querySelectorAll('[data-photo-src]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));
    });
    root.addEventListener('change',event=>{
      if(!event.target.matches('[data-variant]'))return;
      const selected=event.target.selectedOptions[0];
      if(!selected)return;
      root.querySelectorAll('[data-price]').forEach(price=>price.textContent=selected.dataset.price);
      const showComparison = selected.dataset.showCompare === 'true';
      root.querySelectorAll('[data-compare-wrap], [data-now-label]').forEach(element => { element.hidden = !showComparison; });
      root.querySelectorAll('[data-compare-price]').forEach(element => { if (element.tagName === 'S') element.textContent = selected.dataset.comparePrice; });
      root.querySelectorAll('[data-buy]').forEach(button=>{
        button.disabled=selected.dataset.available!=='true';
        button.querySelector('[data-buy-label]').textContent=button.disabled?button.dataset.soldOut:button.dataset.label;
      });
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAlmaBagLandings);else initAlmaBagLandings();
document.addEventListener('shopify:section:load',initAlmaBagLandings);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alma-collection-product"] && !Shopify.designMode) return;
  try {
    
function initAlmaCollection(){
  document.querySelectorAll('[data-alma-collection]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    root.classList.add('aslp-enhanced');
    const palette=root.querySelector('[data-color-picker]');if(palette)palette.hidden=false;
    const quantity=root.querySelector('input[name="quantity"]');
    const lightbox = root.querySelector('[data-alma-lightbox]');
    if (lightbox) {
      const image = lightbox.querySelector('[data-lightbox-image]');
      const caption = lightbox.querySelector('[data-lightbox-caption]');
      const previous = lightbox.querySelector('[data-lightbox-prev]');
      const next = lightbox.querySelector('[data-lightbox-next]');
      let photos = [], index = 0, opener = null, oldOverflow = '', touchStart = null;
      const displayPhoto = () => {
        const source = photos[index];
        image.src = source.href;
        image.alt = source.querySelector('img')?.alt || '';
        caption.textContent = (index + 1) + ' / ' + photos.length;
        previous.disabled = next.disabled = photos.length < 2;
      };
      const stepPhoto = direction => { index = (index + direction + photos.length) % photos.length; displayPhoto(); };
      root.addEventListener('click', event => {
        const link = event.target.closest('.aslp-grid-photo');
        if (!link || !root.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        photos = Array.from(link.closest('[data-color-gallery]').querySelectorAll('.aslp-grid-photo'));
        index = photos.indexOf(link); opener = link; displayPhoto();
        oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        lightbox.showModal();
      });
      previous.addEventListener('click', () => stepPhoto(-1));
      next.addEventListener('click', () => stepPhoto(1));
      lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());
      lightbox.addEventListener('close', () => { document.documentElement.style.overflow = oldOverflow; opener?.focus({preventScroll:true}); image.removeAttribute('src'); });
      lightbox.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); stepPhoto(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); stepPhoto(-1); }
      });
      image.addEventListener('touchstart', event => { touchStart = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null; }, {passive:true});
      image.addEventListener('touchend', event => {
        if (!touchStart || !event.changedTouches.length || event.touches.length) return;
        const dx = event.changedTouches[0].clientX - touchStart.x, dy = event.changedTouches[0].clientY - touchStart.y;
        touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)*1.3) stepPhoto(dx < 0 ? 1 : -1);
      }, {passive:true});
    }

    root.querySelectorAll('.aslp-purchase-accordions details').forEach(panel=>{
      const summary=panel.querySelector('summary');
      summary.addEventListener('click',event=>{
        if(matchMedia('(prefers-reduced-motion: reduce)').matches||!panel.animate)return;
        event.preventDefault();
        if(panel.dataset.animating)return;
        const wasOpen=panel.open;
        const from=panel.getBoundingClientRect().height;
        if(!wasOpen)panel.open=true;
        const to=wasOpen?summary.getBoundingClientRect().height+1:panel.getBoundingClientRect().height;
        panel.dataset.animating='true';panel.style.overflow='hidden';
        const animation=panel.animate([{height:from+'px'},{height:to+'px'}],{duration:220,easing:'cubic-bezier(.2,.6,.3,1)'});
        const finish=()=>{if(wasOpen)panel.open=false;panel.style.overflow='';delete panel.dataset.animating;};
        animation.onfinish=finish;animation.oncancel=finish;
      });
    });
    root.addEventListener('click',event=>{
      const benefit=event.target.closest('[data-open-panel]');
      if(benefit){const panel=document.getElementById(benefit.dataset.openPanel);if(panel){panel.open=true;panel.querySelector('summary').focus({preventScroll:true});panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}}
      const thumb=event.target.closest('[data-photo-src]');
      if(thumb){const main=root.querySelector('.aslp-main-photo');if(main){main.src=thumb.dataset.photoSrc;main.srcset=thumb.dataset.photoSrcset;main.alt=thumb.dataset.photoAlt||'';root.querySelectorAll('.aslp-thumb').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));}}
      const step=event.target.closest('[data-quantity-step]');
      if(step&&quantity){if(Number(step.dataset.quantityStep)>0)quantity.stepUp();else quantity.stepDown();quantity.dispatchEvent(new Event('change',{bubbles:true}));}
    });
    root.addEventListener('change',event=>{
      if(event.target.matches('[data-color-variant]')){const picker=root.querySelector('[data-variant]');if(picker){picker.value=event.target.value;picker.dispatchEvent(new Event('change',{bubbles:true}));}return;}
      if(!event.target.matches('[data-variant]'))return;
      const selected=event.target.selectedOptions[0];if(!selected)return;
      root.querySelector('input[name="id"]').value=selected.value;
      root.querySelectorAll('.aslp-price [data-price],.aslp-mobile-buy [data-price]').forEach(price=>price.textContent=selected.dataset.price);
      const previousPrice=root.querySelector('[data-previous-price]');if(previousPrice){previousPrice.hidden=selected.dataset.showCompare!=='true';previousPrice.querySelector('[data-compare-price]').textContent=selected.dataset.comparePrice;}
      root.querySelectorAll('[data-color-variant]').forEach(input=>input.checked=input.value===selected.value);
      const colorName=root.querySelector('[data-selected-color]');if(colorName)colorName.textContent=selected.textContent.trim();
      root.querySelectorAll('[data-color-gallery]').forEach(gallery=>{gallery.hidden=gallery.dataset.colorGallery!==selected.value;});
      if(root.dataset.designMode!=='true'){const url=new URL(window.location.href);url.searchParams.set('variant',selected.value);history.replaceState(null,'',url);}

      if(quantity){quantity.min=selected.dataset.min||'1';quantity.step=selected.dataset.step||'1';if(selected.dataset.max)quantity.max=selected.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;}
      root.querySelectorAll('[data-buy]').forEach(button=>{button.disabled=selected.dataset.available!=='true';button.querySelector('[data-buy-label]').textContent=button.disabled?button.dataset.soldOut:button.dataset.label;});
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAlmaCollection);else initAlmaCollection();
document.addEventListener('shopify:section:load',initAlmaCollection);

function initAlmaRelatedColors(){
  document.querySelectorAll('[data-alma-related]').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    section.addEventListener('click',event=>{
      const button=event.target.closest('[data-related-variant]');
      if(!button)return;
      const card=button.closest('[data-related-card]');
      card.querySelectorAll('[data-related-link]').forEach(link=>link.href=button.dataset.url);
      const image=card.querySelector('[data-related-image]');
      if(button.dataset.image){image.src=button.dataset.image;image.alt=button.dataset.alt;}
      card.querySelector('[data-related-color]').textContent=button.dataset.color;
      card.querySelector('[data-related-price]').textContent=button.dataset.price;
      const compare=card.querySelector('[data-related-compare]');compare.textContent=button.dataset.compare;compare.hidden=button.dataset.showCompare!=='true';
      card.querySelectorAll('[data-related-variant]').forEach(swatch=>swatch.setAttribute('aria-pressed',String(swatch===button)));
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAlmaRelatedColors);else initAlmaRelatedColors();
document.addEventListener('shopify:section:load',initAlmaRelatedColors);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
